import { render } from "./InputRestricted.vue?vue&type=template&id=531134f8"
import script from "./InputRestricted.vue?vue&type=script&lang=js"
export * from "./InputRestricted.vue?vue&type=script&lang=js"

import "./InputRestricted.vue?vue&type=style&index=0&id=531134f8&lang=css"

import exportComponent from "/builds/vrs/docker/web/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__